module.exports = __webpack_public_path__ + "media/images/G-04-53eea9797c471ca55e0e09cd988fee97.svg";